import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const serviceData = [
  {
    icon: 'ri-alarm-line',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
    labelKey: 'svc1_label',
    labelEn: 'Morning Call',
    descKey: 'svc1_desc',
    detail: '프런트에 원하시는 시간을 말씀해 주시면 정확한 시간에 모닝콜 서비스를 제공해 드립니다. 중요한 일정이 있으신 분들께 특히 추천드립니다.',
    img: 'https://public.readdy.ai/ai/img_res/fbd46b0df93eb625dbf46593f67901d0.jpg',
  },
  {
    icon: 'ri-customer-service-2-line',
    color: 'text-rose-600',
    bg: 'bg-rose-50',
    labelKey: 'svc2_label',
    labelEn: '24H Concierge',
    descKey: 'svc2_desc',
    detail: '24시간 365일 프런트 데스크를 운영합니다. 관광 정보, 교통 안내, 짐 보관 등 모든 문의에 친절하게 응대해 드립니다.',
    img: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/61169bea203fb1408680167274008085.png',
  },
  {
    icon: 'ri-shield-check-line',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    labelKey: 'svc3_label',
    labelEn: 'Security',
    descKey: 'svc3_desc',
    detail: 'CCTV 및 전자 도어락 시스템으로 24시간 보안을 유지합니다. 안전하고 편안한 숙박 환경을 제공해 드립니다.',
    img: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/2a7d5f5c5832307f7d1f8d2f4dcf3215.png',
  },
  {
    icon: 'ri-wifi-line',
    color: 'text-sky-600',
    bg: 'bg-sky-50',
    labelKey: 'svc4_label',
    labelEn: 'Free Wi-Fi',
    descKey: 'svc4_desc',
    detail: '전 객실 및 공용 공간에서 무료 고속 와이파이를 이용하실 수 있습니다. 별도 비밀번호 없이 자동 연결됩니다.',
    img: 'https://readdy.ai/api/search-image?query=person%20using%20laptop%20in%20hotel%20room%2C%20free%20wifi%2C%20comfortable%20hotel%20interior%2C%20warm%20lighting%2C%20modern%20technology%2C%20Seoul%20hotel%20guest&width=600&height=380&seq=youngbin-svc-4&orientation=landscape',
  },
  {
    icon: 'ri-drop-line',
    color: 'text-teal-600',
    bg: 'bg-teal-50',
    labelKey: 'svc5_label',
    labelEn: 'Sauna',
    descKey: 'svc5_desc',
    detail: '호텔 내 사우나 시설을 운영합니다. 여행의 피로를 말끔히 풀어드리는 힐링 공간입니다. 투숙객은 할인된 가격으로 이용 가능합니다.',
    img: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/ef9a6111aa427630e1bd3dc1d6177e7d.png',
  },
  {
    icon: 'ri-car-line',
    color: 'text-orange-600',
    bg: 'bg-orange-50',
    labelKey: 'svc6_label',
    labelEn: 'Parking',
    descKey: 'svc6_desc',
    detail: '호텔 인근 주차 공간을 제공합니다. 차량 이용 고객분들께서는 체크인 시 프런트에 문의해 주시기 바랍니다.',
    img: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/f2607ced7a40e94118cc3f8962631a5d.jpeg',
  },
];

const Services = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState(0);

  return (
    <section id="services" className="py-16 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <p className="text-amber-700 text-xs tracking-[0.3em] uppercase mb-3">{t('svc_tag')}</p>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('svc_title')}
          </h2>
          <p className="text-gray-500 text-xs md:text-sm mt-2 md:mt-3">{t('svc_subtitle')}</p>
        </div>

        {/* Service Icon Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 md:gap-4 mb-8 md:mb-12">
          {serviceData.map((svc, idx) => (
            <button
              key={svc.labelKey}
              onClick={() => setActive(idx)}
              className={`flex flex-col items-center text-center p-2 md:p-4 rounded-xl border-2 transition-all duration-300 cursor-pointer ${
                active === idx
                  ? 'border-amber-500 bg-white'
                  : 'border-transparent bg-white hover:border-amber-200'
              }`}
            >
              <div className={`w-10 h-10 md:w-14 md:h-14 flex items-center justify-center rounded-full mb-2 md:mb-3 ${active === idx ? svc.bg : 'bg-stone-100'}`}>
                <i className={`${svc.icon} text-xl md:text-2xl ${active === idx ? svc.color : 'text-gray-400'}`} />
              </div>
              <p className="text-xs text-amber-700 mb-0.5 tracking-wide hidden sm:block">{svc.labelEn}</p>
              <p className={`text-xs font-semibold leading-tight ${active === idx ? 'text-amber-800' : 'text-gray-600'}`}>
                {t(svc.labelKey)}
              </p>
            </button>
          ))}
        </div>

        {/* Service Detail */}
        <div className="flex flex-col lg:flex-row gap-0 items-stretch bg-white rounded-2xl overflow-hidden border border-stone-100">
          {/* Image */}
          <div className="w-full lg:w-1/2 h-56 md:h-72 lg:h-auto overflow-hidden">
            <img
              src={serviceData[active].img}
              alt={t(serviceData[active].labelKey)}
              className="w-full h-full object-cover object-top transition-all duration-500"
            />
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2 p-6 md:p-8 lg:p-10 flex flex-col justify-center">
            <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-5">
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full ${serviceData[active].bg}`}>
                <i className={`${serviceData[active].icon} text-xl md:text-2xl ${serviceData[active].color}`} />
              </div>
              <div>
                <p className="text-xs text-amber-700 tracking-widest uppercase">{serviceData[active].labelEn}</p>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {t(serviceData[active].labelKey)}
                </h3>
              </div>
            </div>

            <p className="text-gray-500 text-sm leading-relaxed mb-2 md:mb-3">{t(serviceData[active].descKey)}</p>
            <p className="text-gray-600 text-sm leading-relaxed">{serviceData[active].detail}</p>

            <div className="mt-6 md:mt-8 pt-5 md:pt-6 border-t border-stone-100 flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-phone-line text-amber-700 text-lg" />
              </div>
              <a
                href="tel:0222771141"
                className="text-amber-700 text-sm font-medium hover:text-amber-800 cursor-pointer whitespace-nowrap"
              >
                문의하기: 02) 2277-1141~4
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Services;
